module.exports = __webpack_public_path__ + "static/media/bed-space.06ffddff.svg";